export const formatLastFour = (phone: string) => phone ? phone.replace(/\D/g, '').slice(-4) : '';
